import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { PageHero } from "@/components/PageHero";
import { FleetSpecs } from "@/components/FleetSpecs";
import { usePageSeo } from "@/hooks/usePageSeo";
import { images } from "@/data/site";

export default function EquipmentPage() {
  usePageSeo({ title: "Equipment Rental & Fleet Specifications | Shyam Equipment and Infratech", description: "Cranes, manlifts, excavators, loaders, trailers, trucks, dumpers, DG sets, and air compressors available for PAN India industrial project rental.", path: "/equipment" });
  return (
    <main className="text-industrial-text" data-testid="equipment-page">
      <Header />
      <PageHero eyebrow="Equipment Rental" title="Plant and machinery with project-ready support" description="Well-maintained rental equipment for lifting, access, earthmoving, transport, power, and compressed-air requirements, with operators where required." image={images.equipment} imageAlt="Excavators working at an industrial construction site" primaryLabel="Hire Equipment" testId="equipment-page-hero" />
      <FleetSpecs />
      <Footer />
    </main>
  );
}
